(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/leave-team-popover-item.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/leave-team-popover-item.js');
'use strict';

const _svs$arena$pages$team = svs.arena.pages.teams.dialogs,
  showLeaveTeamError = _svs$arena$pages$team.showLeaveTeamError,
  showLeaveTeamQuestionDialog = _svs$arena$pages$team.showLeaveTeamQuestionDialog,
  showLeaveTeamSuccess = _svs$arena$pages$team.showLeaveTeamSuccess;
const MemberPopoverItem = svs.arena.pages.teams.components.MemberPopoverItem;
const removeTeam = svs.arena.store.teams.actions.removeTeam;
const deleteMemberAsync = svs.arena.service.teamsService.deleteMemberAsync;
const LeaveTeamPopoverItem = _ref => {
  let teamId = _ref.teamId,
    teamName = _ref.teamName,
    memberBalance = _ref.memberBalance;
  const dispatch = ReactRedux.useDispatch();
  const customerId = ReactRedux.useSelector(state => state.teams.customerId);
  const handleClick = async () => {
    if (!customerId) {
      showLeaveTeamError();
      svs.arena.logger.info('LeaveTeamPopoverItem, CustomerId missing couldnt leave team');
      return;
    }
    if (await showLeaveTeamQuestionDialog("".concat(teamName), memberBalance)) {
      const _await$deleteMemberAs = await deleteMemberAsync(teamId, customerId),
        error = _await$deleteMemberAs.error;
      if (error) {
        showLeaveTeamError();
        svs.arena.logger.info('LeaveTeamPopoverItem, Failed to leave team', error);
        return;
      }
      const track = {
        category: 'spela-tillsammans',
        action: 'leave_team',
        opt_label: 'leave'
      };
      svs.components.analytics.trackEvent(track);
      showLeaveTeamSuccess(teamName, memberBalance);
      dispatch(removeTeam(teamId));
    } else {
      const track = {
        category: 'spela-tillsammans',
        action: 'leave_team',
        opt_label: 'cancel'
      };
      svs.components.analytics.trackEvent(track);
    }
  };
  return React.createElement(MemberPopoverItem, {
    onClick: handleClick
  }, "L\xE4mna laget");
};
svs.arena.pages.teams.components.LeaveTeamPopoverItem = LeaveTeamPopoverItem;

 })(window);